import React, { useState } from "react";
import { TfiViewListAlt, TfiViewGrid } from "react-icons/tfi";

const SearchBar = (props) => {

  const deepEqual = (a, b)=>{
    if (a === b) return true;
  
    if (typeof a !== "object" || typeof b !== "object" || a == null || b == null)
      return false;
  
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
  
    if (keysA.length !== keysB.length) return false;
  
    for (let key of keysA) {
      if (!keysB.includes(key) || !deepEqual(a[key], b[key])) return false;
    }

    return true;
  }

  const areObjectValuesIdentical = (obj1, obj2) => {
    const values1 = Object.values(obj1);
    const values2 = Object.values(obj2);
  
    if (values1.length !== values2.length) return false;
  
    for (let i = 0; i < values1.length; i++) {
      if (values1[i] !== values2[i]) return false;
    }
  
    return true;
  }
  
  const filterlistO =  {
    asc: 'asc',
    limit : 50,
    skip : 0,
    roleName: 'null',
    myUser: false,
    grpByrole : false,
    agr: 1,
    sortBy: 'createdAt',
    userID: '',
    search: ''
  }

  const filterlist =  {
    asc: 'asc',
    limit : 50,
    skip : 0,
    roleName: 'null',
    myUser: false,
    grpByrole : true,
    agr: 2,
    sortBy: 'createdAt',
    userID: '',
    search: ''
  }
  
  const {
    
    infoSource, 
    setSowFilterOurTeam,
    setFilterUserProd,
    getFilterUserProd,
    loadAllMyUserRef,
    infoFil,
    setText,
    handleFilters,
    showTable,
    setShowTable,
    getFilterOurTeam, 
    setFilterOurTeam,
    Shop=false,
  } = props
 const {
  search
 } = getFilterUserProd
 const [checked, setChecked] = useState([]);

 const handleToggle = (c, d, cat) => () => {
  let existingIndex;
  let updatedValues;

  // Find the index of the filter group by name (d)
  checked.forEach((filter, index) => {
    if (filter.name === d) {
      existingIndex = index;
    }
  });

  // Clone the checked array to avoid mutating state directly
  const newChecked = [...checked];

  if (existingIndex !== undefined) {
    // Check if the value (c) exists in the selected filter group
    const valueIndex = newChecked[existingIndex].value.indexOf(c);
    if (valueIndex === -1) {
      // Add value to the filter group if not present
      newChecked[existingIndex].value.push(c);
    } else {
      // Remove value if it already exists
      newChecked[existingIndex].value.splice(valueIndex, 1);
    }
    updatedValues = newChecked[existingIndex].value;
  } else {
    // If the filter group doesn't exist, add it
    newChecked.push({ name: d, value: [c] });
    updatedValues = newChecked[newChecked.length - 1].value;
  }

  // Update state and trigger external function
  setChecked(newChecked);
  handleFilters(updatedValues, `filterProduct.filter.${d}`);
};

  // Fonction appelée à chaque changement dans le champ de recherche
  const handleSearch = (e) => {
    const value = e.target.value;
 setFilterUserProd({...getFilterUserProd,  search: value})
  };

  const bntViewLIstGrid = (e, f, g)=>{
    setShowTable(!showTable)
    const bntInside = (a, b)=>{
      if(areObjectValuesIdentical(a, b)){
        setFilterOurTeam(b)
        loadAllMyUserRef(b)
      }else{
        setFilterOurTeam(a)
        loadAllMyUserRef(a)
      }
    }
    if(!showTable){
      bntInside(f, f)
    }else{
      bntInside(e, g)
    }

  }

  return (
    <div style={styles.container}>
       <div className="btn btn-dark btn-md py-1 rounded-4" onClick={()=>setSowFilterOurTeam(true)}>
                    {/* Filters */}
                    {infoSource.language(infoSource, "title", "filters")} 
          </div>
      <input
        type="text"
        placeholder="Search by firstname, lastname, or email..."
        value={search}
        onChange={handleSearch}
        style={styles.input}
      />
     {!Shop && <div className="ml-4" style={{fontSize: '23px'}} onClick={()=>bntViewLIstGrid(filterlistO, filterlist, getFilterOurTeam)}>
      {showTable?
       <TfiViewGrid/>
      :
      <TfiViewListAlt/>
      }
  </div>}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },
  input: {
    width: "100%",
    maxWidth: "400px",
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "16px",
  },
};

export default SearchBar;
